import { render, staticRenderFns } from "./Reward.vue?vue&type=template&id=20fb0960&scoped=true"
import script from "./Reward.vue?vue&type=script&lang=ts"
export * from "./Reward.vue?vue&type=script&lang=ts"
import style0 from "./Reward.vue?vue&type=style&index=0&id=20fb0960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb0960",
  null
  
)

export default component.exports